<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      title="选择工厂"
      width="900px"
      top="5vh">
    <vm-table
        ref="vmTable"
        :columns-btn-show="false"
        :filter.sync="filter"
        module="basic"
        url="factorys">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="工厂编号：">
            <el-input v-model.trim="filter.factoryNo" placeholder="请输入工厂编号" clearable/>
          </vm-search>
          <vm-search label="工厂名称：">
            <el-input v-model.trim="filter.factoryName" placeholder="请输入工厂名称" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="factoryNo" align="center" label="工厂编号" width="120"/>
      <el-table-column prop="factoryName" align="left" label="工厂名称"/>
      <el-table-column label="操作" align="center" width="80px" prop="action">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="onSelect(scope.row)"> 选择 </el-button>
        </template>
      </el-table-column>
    </vm-table>
  </el-dialog>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";

  export default {
    name: "FactorySelect",
    components: { VmTable },
    data() {
      return {
        dialogVisible: false,
        filter: {},
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },

      onSelect(row) {
        this.$emit("select", row);
        this.dialogVisible = false;
      },
    },
  };
</script>